<form class="form-container" [formGroup]="formControls" autocomplete="off" action="">
  <div class="label-wrapper" *ngIf="changePassword">
    <label>{{'NewPassword' | cpLoginTranslate | async}}:</label>
  </div>
  <div class="label-wrapper" *ngIf="!changePassword">
    <label>{{'Password' | cpLoginTranslate | async}}:</label>
  </div>
  <div class="input-wrapper">
    <input #Password [type]="!passwordVisible ? 'password' : 'text'" formControlName="password" autocomplete="off" autocorrect="off" autocapitalize="off" maxlength="25"
            (keypress)="resetErrors()"/>
    <span class="field-icon-wrapper">
      <i class="field-icon" [ngClass]="passwordVisible ? 'pp-icon-hide': 'pp-icon-show'" [attr.aria-hidden]="true" (click) = "togglePasswordVisibility()"></i>
    </span>
    <label *ngIf="changePassword && formControls.controls['password'].touched && formControls.controls['password'].hasError('required')" class="text-invalid">
      {{'FillNewPassword' | cpLoginTranslate | async}}
    </label>
    <label *ngIf="!changePassword && formControls.controls['password'].touched && formControls.controls['password'].hasError('required')" class="text-invalid">
      {{'FillPassword' | cpLoginTranslate | async}}
    </label>
    <label *ngIf="passwordRecentlyUsed && formControls.controls['password'].touched && formControls.controls['password'].valid" class="text-invalid">
      {{'PasswordRecentlyUsed' | cpLoginTranslate | async}}
    </label>
    <label *ngIf="invalidCharacters && formControls.controls['password'].touched && formControls.controls['password'].valid" class="text-invalid">
      {{'PasswordContainsInvalidChars' | cpLoginTranslate | async}}
    </label>
    <div class="password-validation-wrapper">
      <label *ngIf="validateNumber" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('hasNumber')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}} {{'AtLeastOneNumber' | cpLoginTranslate | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('hasNumber')"></i>
      </label>
    </div>
    <div class="password-validation-wrapper">
      <label *ngIf="validateUpperChar" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('hasCapitalCase')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}}{{'AtLeastOneUpperCaseChar' | cpLoginTranslate | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('hasCapitalCase')"></i>
      </label>
    </div>
    <div class="password-validation-wrapper">
      <label *ngIf="validateLowerChar" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('hasSmallCase')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}}{{'AtLeastOneLowerCaseChar' | cpLoginTranslate | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('hasSmallCase')"></i>
      </label>
    </div>
    <div class="password-validation-wrapper">
      <label *ngIf="validateSpecialChar" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('hasSpecialCharacters')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}}{{'AtLeastOneSpecialChar' | cpLoginTranslate | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('hasSpecialCharacters')"></i>
      </label>
    </div>
    <div class="password-validation-wrapper">
      <label *ngIf="validateLength" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('minlength')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}}{{'PasswordMinimumLength' | cpLoginTranslate: [passwordLength] | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('minlength')"></i>
      </label>
    </div>
    <div class="password-validation-wrapper">
      <label *ngIf="validateConsecutiveChars" [ngClass]="formControls.controls['password'].hasError('required') || formControls.controls['password'].hasError('lessThanTwoConsecutiveChars')  ? 'password-pattern-invalid' :'password-pattern-valid'">
        {{'• '}}{{'AtMostTwoConsecutiveChars' | cpLoginTranslate | async}}
        <i class="pp-icon-status_confirm" *ngIf="!formControls.controls['password'].hasError('required') && !formControls.controls['password'].hasError('lessThanTwoConsecutiveChars')"></i>
      </label>
    </div>
  </div>
  <div class="label-wrapper">
    <label>{{'ConfirmPassword' | cpLoginTranslate | async}}:</label>
  </div>
  <div class="input-wrapper">
    <input [type]="!passwordVisible ? 'password' : 'text'" formControlName="confirmPassword" autocomplete="off" autocorrect="off" autocapitalize="off" maxlength="25" />
    <span class="field-icon-wrapper">
      <i class="field-icon" [ngClass]="passwordVisible ? 'pp-icon-hide': 'pp-icon-show'" [attr.aria-hidden]="true" (click) = "togglePasswordVisibility()"></i>
    </span>
    <label *ngIf="formControls.controls['password'].touched && formControls.controls['confirmPassword'].hasError('passwordsMismatch')" class="text-invalid">
      {{'PasswordMismatch' | cpLoginTranslate | async}}
    </label>
  </div>
</form>

